import once from 'lodash/once'

import { loadScript } from '../utils'

declare global {
  interface Window {
    ytag: (...args: Array<any>) => void
    yjDataLayer: Array<any>
  }
}

enum YahooTagType {
  YDA = 'yjad_conversion',
  YSS = 'yss_conversion',
}

const YahooTag = {
  initialize: once(() => {
    loadScript('https://s.yimg.jp/images/listing/tool/cv/ytag.js', '', true)

    window.yjDataLayer = window.yjDataLayer || []
    window.ytag = function () {
      window.yjDataLayer.push(arguments)
    }
    window.ytag({ type: 'ycl_cookie' })
  }),

  sendYtag(type: YahooTagType, config: Record<string, string>) {
    if (!window.ytag) {
      YahooTag.initialize()
    }

    window.ytag({
      type,
      config,
    })
  },

  track() {
    YahooTag.sendYtag(YahooTagType.YDA, {
      yahoo_ydn_conv_io: 's9RT6Ese9sjmpKuQay-P-A..',
      yahoo_ydn_conv_label: '88ZNADFV7FV0LWSFT5B890119',
      yahoo_ydn_conv_transaction_id: '',
      yahoo_ydn_conv_value: '0',
    })

    YahooTag.sendYtag(YahooTagType.YSS, {
      yahoo_conversion_id: '1001239310',
      yahoo_conversion_label: '5TmeCNvRjqkDELHXh70o',
      yahoo_conversion_value: '0',
    })
  },
}

export default YahooTag
